import axios from "axios";
import config from "config";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

// module-level cache
let networkCache = null;
let networkPromise = null;

export async function fetchNetwork() {
  // If already cached, do not hit the API again
  if (networkCache) return networkCache;

  // If an active request exists, wait for it
  if (networkPromise) return networkPromise;

  networkPromise = axios
    .get(`${API_URL}/GetNetwork`, {
      headers: {
        "X-API-Key": API_TOKEN,
      },
    })
    .then((response) => {
      const data = response.data;

      if (!data || data.type !== "FeatureCollection") {
        console.warn("GetNetwork did not return a FeatureCollection", data);
        networkCache = {
          type: "FeatureCollection",
          features: [],
        };
      } else {
        networkCache = data;
      }

      networkPromise = null;
      return networkCache;
    })
    .catch((err) => {
      console.error("Error fetching network", err);
      networkPromise = null;
      networkCache = {
        type: "FeatureCollection",
        features: [],
      };
      return networkCache;
    });

  return networkPromise;
}
